import * as React from 'react';
import FieldBase from './FieldBase';
import { Row, Col } from 'reactstrap';
import FieldTypes from './enums/FieldTypes';
import { IDateFieldProperties } from './DateField';
import SelectField from './SelectField';
import { IFieldEvent, ISelectFieldItem } from './interfaces';

const monthSelectFieldItems: ISelectFieldItem[] = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" }
];

const yearSelectFieldItems: ISelectFieldItem[] = [];
for (var i = (new Date()).getUTCFullYear(); i >= 1900; i--) {
  yearSelectFieldItems.push({ label: i.toString(), value: i.toString() });
}

const FullDateRegEx = /^\d{4}-\d{2}.*$/;
const MonthRegEx = /^-\d{2}.*$/;
const YearRegEx = /^\d{4}-$/;

export default class MonthYearDateField extends React.PureComponent<IDateFieldProperties> {
  constructor(props: IDateFieldProperties) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event: IFieldEvent) {
    const targetParts = event.name.split('_');
    const target = targetParts[targetParts.length - 1];
    let [month, year] = this.parseValue();
    if (target === 'month') {
      month = event.value;
    } else { 
      year = event.value;
    }
    
    let value = `${year}-${month}`;
    value = value === "-" ? "" : value;

    if (this.props.onChange !== undefined) {
      this.props.onChange({
        id: this.props.id,
        name: this.props.id,
        value
      });
    }
  }

  componentDidUpdate(prevProps: IDateFieldProperties) {
    if (prevProps.value !== this.props.value || prevProps.max !== this.props.max) {
      //Trigger re-validate      
      let [ valid, message ] = this.validate();
      if (this.props.onValidate !== undefined) {        
        this.props.onValidate({
          name: this.props.id,
          result: valid,
          message: message
        });
      }
    }
  }

  validate() : [valid: boolean, message?: string] {
    let [month, year] = this.parseValue();
    if (this.props.required && 
        (year === undefined || year.trim().length === 0
          || month === undefined || month.trim().length === 0)) {
      return [false, `${this.props.label} is required`];
    }
  
    if ((year === undefined || year.trim().length === 0)
      && (month === undefined || month.trim().length === 0)) {
      return [true, undefined];
    }
  
    if (year === undefined || year.trim().length === 0) {
      return [false, "You must select a year"];
    }
  
    if (month === undefined || month.trim().length === 0) {
      return [false, "You must select a month"];
    }

    var thisDate = new Date(`${year}-${month}`);
    if (this.props.max !== undefined && FullDateRegEx.test(this.props.max)) {
      var maxDate = new Date(this.props.max);
      if (!isNaN(maxDate.getTime()) && thisDate > maxDate) {
        return [false, this.props.maxErrorMessage || `Must be before ${this.props.max}`];
      }
    }

    return [ true, undefined ];
  }

  parseValue() : [month: string, year: string] {
    let month = "";
    let year = "";
    if (this.props.value !== undefined && this.props.value.trim().length > 0) {
      if (MonthRegEx.test(this.props.value)) {
        month = this.props.value.substring(1);
      } else if (YearRegEx.test(this.props.value)) {
        year = this.props.value.substring(0,4);
      } else {
        const date = new Date(this.props.value);
        month = (date.getUTCMonth() + 1).toString();
        month = month.length === 1 ? `0${month}` : month;
        year = date.getUTCFullYear().toString();
      }
    }
    return [month, year];
  }

  render() {   
    let [month, year] = this.parseValue();
    return <React.Fragment>
      <FieldBase key={`${this.props.id}_date_range`} {...this.props} type={FieldTypes.TEXT}>
        <Row key={`${this.props.id}_field_group_row`}>
          <Col key={`${this.props.id}_field_group_row_month`} xs={6} className="text-right">
            <SelectField items={monthSelectFieldItems} {...this.props} id={`${this.props.id}_month`} placeholder="Month" value={month} onChange={this.onChange} label="" message="" />
          </Col>
          <Col key={`${this.props.id}_field_group_row_year`} xs={6} className="text-left">
            <SelectField items={yearSelectFieldItems} {...this.props} id={`${this.props.id}_year`} placeholder="Year" value={year} onChange={this.onChange} label="" message="" />
          </Col>
        </Row>
        { this.props.valid === false && <Row>
            <Col xs={12} className="text-left">
              <span className="hcs-label-text__error-msg">{this.props.message}</span>
            </Col>
          </Row>
          }
      </FieldBase>
    </React.Fragment>;
  }
}